module.exports = __webpack_public_path__ + "static/Come uscire fuori dalle case su Adopt Me-e3d42f6bb31e14b5a02efca78c29e578.mp4";